import { ConversationMembersData } from "@virtualprogaming/js-public-sdk";
import classNames from "classnames";
import React, { FC, useMemo } from "react";

import { useChatAuthUserData } from "~/ui/context";
import { useScreenMd } from "~/utils";

export const MembersPreview: FC<{
  members: ConversationMembersData[];
}> = ({ members }) => {
  const { chatAuthUser } = useChatAuthUserData();
  const isDesktop = useScreenMd();
  const result = useMemo(() => {
    return members
      .filter(({ id }) => id !== chatAuthUser?.user?.id)
      .map((member) => member.display_name)
      .join(", ");
  }, [chatAuthUser?.user?.id, members]);

  return (
    <div className={classNames("flex mg-l-md ", isDesktop ? "w-80" : "w-70")}>
      <h5 className="text-overflow-el">{result}</h5>
    </div>
  );
};
